const rteTableWrappers = document.querySelectorAll('[data-rich-text-table-wrapper]')

rteTableWrappers.forEach(rte => {
    const tables = rte.querySelectorAll('table')
    
    tables.forEach((table) => {
        if (table.style.float !== '') return
        const wrapper = document.createElement('div')
        wrapper.classList.add('custom-table-wrapper')
        rte.insertBefore(wrapper, table)
        wrapper.appendChild(table)
    })
})